import memoize from 'lodash/memoize';

import {SVG_ICONS} from './icons';
import {SvgIconType} from './types';

const UNREAD_CIRCLE = `<circle cx="18" cy="3.75" r="3.75" fill="#4F44E0"></circle>`;

// Trusted markup from local files we control; keyed on the full prop tuple since
// lodash memoize only keys on the first argument by default. Shared by the React
// (`component.tsx`) and snabbdom (`snabbdom.ts`) forms so both render identical markup.
export const buildIconHtml = memoize(
  (icon: SvgIconType, color?: string, height?: string, hasUnread?: boolean): string | null => {
    const markup: string | undefined = SVG_ICONS[icon];
    if (!markup) {
      return null;
    }
    let html = hasUnread ? markup.replace(`</svg>`, `${UNREAD_CIRCLE}</svg>`) : markup;
    const svgStyle = [color && `color:${color}`, height && `height:${height}`].filter(Boolean).join(`;`);
    if (svgStyle) {
      html = html.replace(/<svg\b/, `<svg style="${svgStyle}"`);
    }
    return html;
  },
  (icon, color, height, hasUnread) => `${icon}|${color ?? ``}|${height ?? ``}|${hasUnread ? 1 : 0}`,
);
